module.exports = __webpack_public_path__ + "static/media/img-topics-sample09.5e160abc.jpg";